//Tells UI what API to call
export const PORTAL_NAME = 'ops'; // advisor
export const PORTAL_DOMAIN = '.circleblack.com'; // .circleblack.com
export const PORTAL_SUBDOMAIN = ''; // could be anything Example: -uat
export const PORTAL_PROTOCOL = 'https://'; // https://

// NODEJS_API_HOST = 'api' + PORTAL_SUBDOMAIN + PORTAL_DOMAIN; // Could be external IP or any full domain (excluding protocol)
export const NODEJS_API_HOST = 'api.circleblack.com'; // Could be external IP or any full domain (excluding protocol)
export const NODEJS_API_PROTOCOL = 'https://'; // https://

export const MEDIA_URL = PORTAL_PROTOCOL + 'media' + PORTAL_DOMAIN + '/'; // url for media server (currently only media server is on prod)
export const API_URL = PORTAL_PROTOCOL + PORTAL_NAME + PORTAL_SUBDOMAIN + PORTAL_DOMAIN + '/api/'; // url for ESB
export const NODEJS_API_URL = NODEJS_API_PROTOCOL + NODEJS_API_HOST + '/'; // url for the node api server

export const PORTAL_CONSOLE_DEBUG = false; // true

export const MAX_PAGINATED_ITEMS = 20; // Maximum number of paginated items to display
